import { render, staticRenderFns } from "./ShowErrors.vue?vue&type=template&id=10ae9ec5&"
import script from "./ShowErrors.vue?vue&type=script&lang=js&"
export * from "./ShowErrors.vue?vue&type=script&lang=js&"
import style0 from "./ShowErrors.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports